<template>
  <svg
    class="loading"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  ><circle
    cx="75"
    cy="50"
    fill="undefined"
    r="3"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.917s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.917s"
    />
  </circle><circle
    cx="71.651"
    cy="62.5"
    fill="undefined"
    r="3"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.833s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.833s"
    />
  </circle><circle
    cx="62.5"
    cy="71.651"
    fill="undefined"
    r="3"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.75s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.75s"
    />
  </circle><circle
    cx="50"
    cy="75"
    fill="undefined"
    r="3"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.667s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.667s"
    />
  </circle><circle
    cx="37.5"
    cy="71.651"
    fill="undefined"
    r="3"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.583s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.583s"
    />
  </circle><circle
    cx="28.349"
    cy="62.5"
    fill="undefined"
    r="3"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.5s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.5s"
    />
  </circle><circle
    cx="25"
    cy="50"
    fill="undefined"
    r="3.40958"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.417s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.417s"
    />
  </circle><circle
    cx="28.349"
    cy="37.5"
    fill="undefined"
    r="4.08158"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.333s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.333s"
    />
  </circle><circle
    cx="37.5"
    cy="28.349"
    fill="undefined"
    r="4.74558"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.25s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.25s"
    />
  </circle><circle
    cx="50"
    cy="25"
    fill="undefined"
    r="4.59042"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.167s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.167s"
    />
  </circle><circle
    cx="62.5"
    cy="28.349"
    fill="undefined"
    r="3.91842"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="-0.083s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="-0.083s"
    />
  </circle><circle
    cx="71.651"
    cy="37.5"
    fill="undefined"
    r="3.25442"
  >
    <animate
      attributeName="r"
      values="3;3;5;3;3"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      repeatCount="indefinite"
      begin="0s"
    />
    <animate
      attributeName="fill"
      values="#0a0a0a;#0a0a0a;#28292f;#0a0a0a;#0a0a0a"
      repeatCount="indefinite"
      times="0;0.1;0.2;0.3;1"
      dur="1s"
      begin="0s"
    />
  </circle></svg>
</template>

<script>
  export default {
    name: 'LoaderImg',
  }
</script>

<style>
  .loading {
    margin: 1em auto;
    width: 3em;
    height: 3em;
    display: block;
  }
</style>
